<template lang="pug">
section#sioux-city.section.page-section.top-section
  .header
    .container(v-parallax="-0.2")
      h1.is-size-1.is-uppercase Sioux City, Iowa
  section.section.page-section
    .container
      .blocks
        .block.is-odd
          .block-image
            img(src="/images/cwo/bridge.jpg")
          .block-details
            .content.mobile-padding
              h3.is-size-2-desktop.is-size-3-touch.is-uppercase In America&rsquo;s Heartland
              p.is-size-5 Cornerstone may be reaching the world, but we&rsquo;re proud to call <a href="https://www.sioux-city.org/" target="_blank">Sioux City, Iowa</a> home. Sioux City is located in the heart of the nation&mdash;where Iowa, Nebraska, and South Dakota meet along the banks of the mighty Missouri River. More than 165,000 people live and work in the region we affectionately call &ldquo;Siouxland.&rdquo;
        .block.is-even
          .block-image
            img(src="/images/cwo/memorial02.jpg")
          .block-details
            .content.mobile-padding
              h3.is-size-2-desktop.is-size-3-touch.is-uppercase A rich history
              p.is-size-5 When visiting Cornerstone, take some time to familiarize yourself with the area&rsquo;s unique history. From <a href="https://www.nps.gov/places/sergeant-floyd-monument.htm" target="_blank">monuments</a> to the intrepid explorers Lewis and Clark to a <a href="http://www.siouxcityhistory.org/notable-people/29-reverend-george-haddock" target="_blank">memorial</a> honoring a Prohibition-era pastor whose faithfulness to the Gospel cost him his life, Sioux City is home to many <a href="http://www.siouxcityhistory.org/historic-sites" target="_blank">historical points of interest</a> that will bring our courageous past&mdash;and present&mdash;to life.
        .block.is-odd
          .block-image
            img(src="/images/cwo/artcenter.jpg")
          .block-details
            .content.mobile-padding
              h3.is-size-2-desktop.is-size-3-touch.is-uppercase Something for Everyone
              p.is-size-5 Traveling with the family? Be sure to visit the <a href="http://www.launchpadmuseum.com/" target="_blank">LaunchPAD Children&rsquo;s Museum</a> or <a href="https://www.coneparksiouxcity.com/" target="_blank">Cone Park</a>. Want a little culture? The <a href="https://www.siouxcitysymphony.org/" target="_blank">Sioux City Symphony</a>, <a href="https://orpheumlive.com/" target="_blank">Broadway at the Orpheum</a>, or our-award winning <a href="https://www.siouxcityartcenter.org/#year=2020&month=7&day=12&view=month" target="_blank">Art Center</a> could be just what you&rsquo;re looking for. For more information on local events, please see Sioux City&rsquo;s <a href="https://www.sioux-city.org/">official website</a>.
      .details
        .content
          .mobile-padding
            h3.is-size-4-desktop.is-size-5-touch.is-uppercase Where to stay
            p.is-size-5 There are plenty of hotels in Sioux City and the surrounding area to fit any budget, but we recommend the following:
          .hotels.columns.is-multiline
            .column.is-one-third
              img(src="/images/cwo/marriot.jpg")
              .mobile-padding
                h4
                  a(href="https://www.marriott.com/hotels/travel/suxmc-south-sioux-city-marriott-riverfront/?scid=45f93f1b-bd77-45c9-8dab-83b6a417f6fe" target="_blank") The Delta
                p Right on the water in South Sioux City, Nebraska, The Delta boasts upscale accommodations and one of the finest restaurants around&mdash;Kahill’s Chophouse.
                p.drive-time.has-text-grey
                  b-icon(icon="clock" size="is-small")
                  span 15 minutes from the church
            .column.is-one-third
              img(src="/images/cwo/courtyard.jpg")
              .mobile-padding
                h4
                  a(href="https://www.marriott.com/hotels/travel/suxcy-courtyard-sioux-city-downtown-convention-center/" target="_blank") Courtyard by Marriott
                p Located in the heart of Historic 4th Street, the Courtyard by Mariott is Sioux City&rsquo;s newest hotel. Mention you&rsquo;re with Cornertsone World Outreach to get a special rate.
                p.drive-time.has-text-grey
                  b-icon(icon="clock" size="is-small")
                  span 10 minutes from the church
            .column.is-one-third
              img(src="/images/cwo/stoney_creek.jpg")
              .mobile-padding
                h4
                  a(href="http://www.stoneycreekhotels.com/hotel/travel/siouxcity/home.do" target="_blank") Stoney Creek
                p In the heart of downtown, Stoney Creek’s rustic décor is anything but ordinary and their suites are spacious enough for the whole family. Be sure to check out the indoor/outdoor year-round pool and Famous Dave’s BBQ next door.
                p.drive-time.has-text-grey
                  b-icon(icon="clock" size="is-small")
                  span 10 minutes from the church
            .column.is-one-third
              img(src="/images/cwo/hampton.jpg")
              .mobile-padding
                h4
                  a(href="https://www.hilton.com/en/hotels/suxsohx-hampton-suites-sioux-city-south/" target="_blank") Hampton Suites
                p Just minutes from Cornerstone, Hampton Suites is affordable and offers convenient access to shopping and local restaurants.
                p.drive-time.has-text-grey
                  b-icon(icon="clock" size="is-small")
                  span 5 minutes from the church
          .airports.mobile-padding
            h3.is-size-4-desktop.is-size-5-touch.is-uppercase Airports
            p.is-size-5 Sioux City has a small regional airport (SUX), but many choose to fly into either Omaha, Nebraska (OMA) or Sioux Falls, South Dakota (FSD) and drive into Sioux City.
            ul.is-size-5
              li SUX (Sioux City)
              li OMA (Omaha&mdash;90 minute drive)
              li FSD (Sioux Falls&mdash;90 minute drive)
</template>

<script>
export default {
  name: 'sioux-city',
};
</script>

<style lang="scss">
#sioux-city {
  @include blocks;
  margin-bottom: 5rem;
  .header {
    @include hero;
    background-image: url('/images/cwo/heartland02.jpg');
    background-position: top;
  }
  .blocks {
    .block {
      .block-image {
        @include blockImage;
      }
    }
  }
  .details {
    margin-top: 5rem;
    .hotels {
      margin-top: 1rem;
      img {
        margin-bottom: 1rem;
      }
      h4 {
        font-family: $body-font;
        font-weight: 700 !important;
        a {
          // color: $grey-darker;
        }
      }
      .drive-time {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 0.45rem;
        }
      }
    }
  }
  @media (max-width: $tablet) {
    .block {
      .block-details {
        text-align: center;
      }
    }
    .airports {
      margin-top: 3.5rem;
    }
  }
}
</style>
